import React, { Component } from "react";
import { toJS } from "mobx";

import PropTypes from "prop-types";
import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";

import Anchor from "../Anchor";
import { MyBag, Checkout } from "npmlinks-constants";

class CheckoutEmptyState extends Component {
  render() {
    return (
      <div className="nw-checkoutemptystate">
        <h2 className="nw-checkoutemptystate-msg">
          {Checkout.CHECKOUTPAGE.CHEKOUT_EMPTY_MSG}
        </h2>
        <div className="nw-checkoutemptystate-actions">
          <Anchor.component
            className="nw-checkoutemptystate-shopnow"
            href="/products"
            to="/products"
            target="_self"
          >
            {Checkout.CHECKOUTPAGE.SHOPNOW_BUTTON}
          </Anchor.component>
        </div>
        <div className="nw-checkoutemptystate-empty-image">
          <img
            className="nw-checkoutemptystate-image"
            src={MyBag.IMAGES.EMPTY_BAG_URL}
            alt={Checkout.CHECKOUT_EMPTY_STATE.IMAGE_ALT_TEXT}
          />
        </div>
      </div>
    );
  }
}

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: CheckoutEmptyState,
  component: CheckoutEmptyState,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CheckoutEmptyState/index.js